import initializeDropdownMenu from './dom/initializeDropdownMenu.js';
import initializePopup from './dom/initializePopup.js';
import initializeEllipsis from './dom/initializeEllipsis.js';
import toggleDropdown from './dom/toggleDropdown.js';

var JsForCss = {
  initializeAll: function(currentElement){
    if(currentElement){
      initializeDropdownMenu(currentElement);
      initializePopup(currentElement);
      initializeEllipsis(currentElement);
    }
  },
  initializeDropdownMenu : initializeDropdownMenu,
  toggleDropdown: toggleDropdown
}

export default JsForCss;